import React from "react";

export const RfmHeader = (props) => {
    return (
        <>
            <thead>
            <tr className={"bg-danger"}>
                <th scope="col" className={"text-white"}>
                    <strong>RFM</strong>
                    <br/>
                    <input className={"form-control text-center"} onChange={props.filter} type={"text"} placeholder={"جستجو"} type={"rfm"}/>

                </th>
                <th scope="col" className={"text-white"}>
                    <strong>R</strong>
                    <br/>
                    <input className={"form-control text-center"}onChange={props.filter} type={"text"} placeholder={"جستجو"} type={"r"}/>
                </th>
                <th scope="col" className={"text-white"}>
                    <strong>F</strong>
                    <br/>
                    <input className={"form-control text-center"}onChange={props.filter} type={"text"} placeholder={"جستجو"} type={"f"}/>

                </th>
                <th scope="col" className={"text-white"}>
                    <strong>M</strong>
                    <br/>
                    <input className={"form-control text-center"}onChange={props.filter} type={"text"} placeholder={"جستجو"} type={"m"}/>

                </th>
                <th scope="col" className={"text-white"}>
                    <strong>کاربر</strong>
                    <br/>
                    <input className={"form-control text-center"}onChange={props.filter} type={"text"} disabled={true} placeholder={"جستجو"} type={"user"}/>

                </th>
            </tr>
            </thead>
        </>
    )
}
